module.exports = __webpack_public_path__ + "img/to-b.17abcc4b.svg";